import React from 'react'
const ListSpan = (props) => {
    return ( 
        <>
        <li className="list-group-item">
          {props.value ? 
            <span className="text-success">
                <i className='bi bi-check-circle-fill'></i> {props.text}
            </span>
            :
            <span className="text-danger">
                    <i className='bi bi-x-circle-fill'></i> {props.text}
            </span>
            }
            </li>
        </>
      
     );
}
 
export default ListSpan;